/**
 * Tailwind class presets for the app-specific Dialog looks. The shared `Dialog.Root` stays
 * style-light; compose these (or your own classes) into its `className` at the call site.
 */

/** Base classes always applied to the native `<dialog>` surface */
export const DIALOG_BASE =
    '!m-auto overscroll-none rounded-[9px] border-none shadow-[0_0_10px_0_#0000001a] focus-visible:outline-none'

/** Desktop sizing: 600px wide from the `md` breakpoint up. */
export const DIALOG_WIDTH_600 = 'md:w-[600px] md:max-w-full'

/** Desktop sizing: 800px wide, capped to the viewport minus a gutter. */
export const DIALOG_WIDTH_800 = 'md:w-[800px] md:max-w-[calc(100vw-48px)]'

/** Dark backdrop that fades to 80% opacity while the dialog is open. */
export const DIALOG_BACKDROP_FADE =
    'backdrop:bg-[#10185a] backdrop:opacity-0 backdrop:transition-opacity backdrop:duration-500 backdrop:ease-in-out open:backdrop:opacity-80'

/** Full-screen, square-cornered on mobile (below the `md` breakpoint). */
export const DIALOG_MOBILE_FULL =
    'max-md:h-full max-md:max-h-full max-md:w-full max-md:max-w-full max-md:rounded-none'

/** Bottom-docked sheet on mobile; centred card from the `md` breakpoint up. */
export const DIALOG_MOBILE_SHEET =
    'max-md:!mb-0 max-md:!mt-auto max-md:!mx-0 max-md:w-full max-md:!max-w-full max-md:rounded-b-none max-md:origin-bottom'
